
/**
  * Do not change! File was auto generate.
  *
  */
import { ReactElement, SVGProps } from 'react';
import { ReactComponent as VideoDurationIconComponent } from "./video-duration-icon.svg";

export const VideoDurationIcon = (props: SVGProps<SVGSVGElement>): ReactElement => {
  return <VideoDurationIconComponent {...props} />;
};
